/** Transient speech wire format. Exactly one canonical PCM data chunk, no metadata. */
export const DICTATION_AUDIO_SAMPLE_RATE = 16_000;
export const DICTATION_AUDIO_MAX_SAMPLES = 60 * DICTATION_AUDIO_SAMPLE_RATE;
export const DICTATION_AUDIO_MAX_BYTES = 44 + DICTATION_AUDIO_MAX_SAMPLES * 2;
export function validateDictationAudio(bytes: Uint8Array): boolean {
  if (
    bytes.byteLength <= 44 ||
    bytes.byteLength > DICTATION_AUDIO_MAX_BYTES ||
    bytes.byteLength % 2 !== 0
  )
    return false;
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const tag = (offset: number, expected: string) =>
    [...expected].every((char, index) => bytes[offset + index] === char.charCodeAt(0));
  return (
    tag(0, 'RIFF') &&
    view.getUint32(4, true) === bytes.byteLength - 8 &&
    tag(8, 'WAVE') &&
    tag(12, 'fmt ') &&
    view.getUint32(16, true) === 16 &&
    view.getUint16(20, true) === 1 &&
    view.getUint16(22, true) === 1 &&
    view.getUint32(24, true) === DICTATION_AUDIO_SAMPLE_RATE &&
    view.getUint32(28, true) === DICTATION_AUDIO_SAMPLE_RATE * 2 &&
    view.getUint16(32, true) === 2 &&
    view.getUint16(34, true) === 16 &&
    tag(36, 'data') &&
    view.getUint32(40, true) === bytes.byteLength - 44
  );
}
